// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2G_T4","location":"Header_location__1Cz9e"};